module.exports = __webpack_public_path__ + "static/Robotic_Mower-36b537e8754714c628a4ac7c72f7e176.png";